module.exports = __webpack_public_path__ + "static/media/33-15.2fe5bae1.mp3";